import React from 'react';
import {Layout, WarningIcon, Text} from '@phonectas/unifon-ui-kit';
import getIconByType from '../../../getIconByType';
import {DATE_FORMATS, dateByCustomFormat, getDateByCustomFormat} from 'utils/date';
import EventDescription from '../EventDescription';
import {InvoiceData} from './types';
import getTitleByType from '../../../getTitleByType';
import {useTranslation} from 'react-i18next';

interface VismaInvoiceProps {
	data: InvoiceData;
}

const VismaInvoice: React.FC<VismaInvoiceProps> = ({data}) => {
	const [t] = useTranslation();
	const isWarning = data?.is_warning;
	const dataFields = data?.data_fields;
	const isCopy = dataFields?.receiver_mail;
	const isChangeDueDate = dataFields?.new_due_date;

	return (
		<Layout gap="sm" fullWidth nowrap fullHeight>
			<Layout direction="column" nowrap gap="md" alignItems="center" style={{width: '42px'}}>
				<Layout>
					{getIconByType(data?.feed_type)}
				</Layout>
				<Layout>
					{
						isWarning && (
							<Layout>
								<WarningIcon color="warning" />
							</Layout>
						)
					}
				</Layout>
			</Layout>
			<Layout direction="column" fullWidth nowrap>
				<Layout direction="row" fullWidth nowrap>
					<Layout direction="column" fullWidth nowrap gap="xs">
						<Layout direction="row" fullWidth alignItems="center" justifyContent="space-between">
							<Text variant="h3">{getTitleByType(data?.feed_type)}</Text>
							<Text color="textSecondary" variant="body1">
								{
									getDateByCustomFormat(data.created_at, DATE_FORMATS.DD_MM_YY_HH_mm)
								}
							</Text>
						</Layout>
						<Layout fullWidth direction="row" nowrap>
							<Layout fullWidth gap="none">
								{
									isCopy && (
										<Layout
											direction="row"
											fullWidth
											justifyContent="space-between"
											gap="none"
											alignItems="center"
											nowrap
										>
											<Text color="textSecondary" variant="body1">{t('Send invoice copy')}</Text>
										</Layout>
									)

								}
								{
									isChangeDueDate && (
										<Layout
											direction="row"
											fullWidth
											justifyContent="space-between"
											gap="none"
											alignItems="center"
											nowrap
										>
											<Text color="textSecondary" variant="body1">
												{
													t('Due date changed to:')} 
												{dateByCustomFormat(dataFields?.new_due_date ?? '', DATE_FORMATS.DD_MM_YY)
												} 
											</Text>
										</Layout>
									)
								}
								<Layout
									direction="row"
									fullWidth
									justifyContent="space-between"
									gap="none"
									alignItems="center"
									nowrap
								>
									<Text color="textSecondary" variant="body1">{data?.data_fields.actor_name}</Text>
								</Layout>
							</Layout>
						</Layout>
						{
							data?.data_fields?.body && (
								<Layout direction="row" nowrap>
									<EventDescription description={data?.data_fields.body} />
								</Layout>
							)
						}
						<Layout direction="row" fullWidth style={{gap: '8px'}}>
						</Layout>
					</Layout>
				</Layout>
			</Layout>
		</Layout>
	)
}

export default VismaInvoice;
